module.exports = __webpack_public_path__ + "static/media/about-1.4bb18733.jpg";